export default __webpack_public_path__ + "static/media/underline.9d287f5c.svg";